<template>
  <BaseItem
      ref="BaseItem"
      :item-uid="itemUid"
      :subtract-height="subtractHeight"
      parentComponent="MachineTable"
      :lock-page="lockPage"
      dto-detail-model="MachineDetailQueryDTO"
      dto-save-model="MachineSaveCommandDTO"
      dto-restore-model="MachineRestoreCommandDTO"
      dto-filter-restore-model="MachineDetailResponseDTO"
      :store-name="store_name"
      :modal-dialog="modalDialog"
      :routeFullScreen="routeFullScreen"
  >
    <template v-slot:body="{editedItem, editedItemCommon, lockPage}">
      <v-row>
        <v-col xl="4" lg="4" md="12" sm="12" xs="12">
          <v-sheet class="mx-3 my-3">
            <v-text-field
                v-model="editedItem.name"
                :label="$t('columns.name')"
                outlined
                :counter="50"
                required
                :filled="lockPage"
                :readonly="lockPage"
                :background-color="getBackColor(editedItem)"
            ></v-text-field>
            <v-select
              v-model="editedItem.task_types"
              item-text="name"
              :label="$t('columns.task_types')"
              outlined
              :items="editedItemCommon.task_types"
              small-chips
              dense
              multiple
              :return-object="true"
            ></v-select>
            <BaseColorPicker v-model="editedItem.color" :readonly="lockPage"></BaseColorPicker>
          </v-sheet>
        </v-col>
        <v-col xl="8" lg="8" md="12" sm="12" xs="12">
          <v-sheet class="overflow-y-auto" :height="height - 120">
            <BaseCardList
                v-if="!!editedItem && editedItem.attributes && !!editedItem.page_properties"
                :item-list="editedItem.attributes"
                :common="editedItemCommon"
                :delete-restore-event="onValidate"
                :default-item="newAttributeItem"
                :correct-default-item="function() {return true}"
                :enable-add-row="function() {return !lockPage}"
                xl="12" lg="12" md="12" sm="12" xs="12"
                :disableDrag="false"
                :disable-item-edit="function(){return lockPage}"
                @change="onValidate()"
            >
              <template v-slot:top>
                <v-toolbar height="30" class="mb-5">
                  <span class="text-h6">{{ $t('columns.attributes') }}</span>
                </v-toolbar>
              </template>
              <template v-slot:body="{item, index, common}">
                <BaseAttributeTemplate :item="item" :readonly="lockPage"></BaseAttributeTemplate>
                <v-spacer></v-spacer>
              </template>
            </BaseCardList>
          </v-sheet>
        </v-col>
      </v-row>
    </template>
  </BaseItem>
</template>

<script>
// import {mapGetters, mapActions} from 'vuex';
// import {mapFields} from 'vuex-map-fields';
import ConfirmDialog from "@/components/Base/ConfirmDialog";
import BaseCardList from "@/components/Base/BaseCardList";
import commonFunction from "@/commonFunction/commonFunction"
import BaseItem from "@/components/Base/BaseItem";
import {v4 as uuidv4} from "uuid";
import BaseAttributeTemplate from "@/components/Base/BaseAttributeTemplate";
import BaseColorPicker from "@/components/Base/BaseColorPicker";


export default {
  name: 'MachineItem',
  props: {
    subtractHeight: {type: [Number], default: 80},
    height: {type: [Number], default: window.innerHeight},
    itemUid: {default: null},
    store_name: {type: [String], default: 'MachineTable'},
    modalDialog: {type: [Boolean], default: false},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    ConfirmDialog,
    BaseItem,
    BaseCardList,
    BaseAttributeTemplate,
    BaseColorPicker,
  },

  computed: {},

  methods: {
    getBackColor(editedItem) {
      if (!!editedItem.color && typeof editedItem.color === 'string') {
        return editedItem.color
      }
      return 'white'
    }
    ,
    onValidate() {
    },
  },

  async mounted() {
  }
  ,

  data() {
    return {
      validateDiff: true,
      validate: null,
      newAttributeItem: {
        name: null,
        deleted: false,
        category: 'number',
      },
    }
  }
}
</script>

<style>
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>

<i18n src=".\locales.json">
</i18n>
